import {
  required, requiredIf,
} from 'vuelidate/lib/validators';

const tenantTypes = [
  'Company',
  'Partnership / Sole Trader',
  'Trust',
];

export default {
  name: 'property-details',
  data: () => ({
    tenantTypes,
  }),
  computed: {
    relatedParty: {
      get() {
        return this.$store.getters['toolkit/getItemData'].property.tenant.relatedParty.toString();
      },
      set(value) {
        this.$store.dispatch('toolkit/updateItemKey', { data: { property: { tenant: { relatedParty: (value === 'true') } } } });
      },
    },
    tenantType: {
      get() {
        return this.$store.getters['toolkit/getItemData'].property.tenant.type;
      },
      set(value) {
        this.$store.dispatch('toolkit/updateItemKey', { data: { property: { tenant: { type: value } } } });
      },
    },
    companyName: {
      get() {
        return this.$store.getters['toolkit/getItemData'].property.tenant.details.companyName;
      },
      set(value) {
        this.$store.dispatch('toolkit/updateItemKey', { data: { property: { tenant: { details: { companyName: value } } } } });
      },
    },
    companyNameLabel() {
      if (this.tenantType === 'Partnership / Sole Trader') {
        return 'How should the documents refer to the tenant?';
      }
      return 'Company Name';
    },
    companyNamePlaceholder() {
      if (this.tenantType === 'Partnership / Sole Trader') {
        return 'Provide the name of the business or the names of the partners';
      }
      return 'Enter Company Name';
    },
    trustName: {
      get() {
        return this.$store.getters['toolkit/getItemData'].property.tenant.details.trustName;
      },
      set(value) {
        this.$store.dispatch('toolkit/updateItemKey', { data: { property: { tenant: { details: { trustName: value } } } } });
      },
    },
    trusteeName: {
      get() {
        return this.$store.getters['toolkit/getItemData'].property.tenant.details.trusteeName;
      },
      set(value) {
        this.$store.dispatch('toolkit/updateItemKey', { data: { property: { tenant: { details: { trusteeName: value } } } } });
      },
    },
    signee: {
      get() {
        return this.$store.getters['toolkit/getItemData'].property.tenant.details.signee;
      },
      set(value) {
        this.$store.dispatch('toolkit/updateItemKey', { data: { property: { tenant: { details: { signee: value } } } } });
      },
    },
    position: {
      get() {
        return this.$store.getters['toolkit/getItemData'].property.tenant.details.position;
      },
      set(value) {
        this.$store.dispatch('toolkit/updateItemKey', { data: { property: { tenant: { details: { position: value } } } } });
      },
    },
  },
  watch: {
    '$v.$invalid': {
      immediate: true,
      handler: function isComponentValid(value) {
        this.$emit('valid', !value);
      },
    },
  },
  validations: {
    relatedParty: {
      required,
    },
    signee: {
      required,
    },
    position: {
      required,
    },
    tenantType: {
      required,
    },
    companyName: {
      required: requiredIf(function companyNameReq() {
        if (this.tenantType === 'Company' || this.tenantType === 'Partnership / Sole Trader') {
          return true;
        }
        return false;
      }),
    },
    trustName: {
      required: requiredIf(function trustNameReq() {
        if (this.tenantType === 'Trust') {
          return true;
        }
        return false;
      }),
    },
    trusteeName: {
      required: requiredIf(function truteeNameReq() {
        if (this.tenantType === 'Trust') {
          return true;
        }
        return false;
      }),
    },
  },
};
